import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  getConfigurations as getConfigurationsApi,
  saveAccount as saveAccountApi,
  deleteAccount as deleteAccountApi,
} from 'util/Api/wechat';

export const getWeChatConfiguration = createAsyncThunk(
  'wechat/configurations',
  async ({ accountId }, { rejectWithValue }) => {
    try {
      return await getConfigurationsApi({ accountId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const saveAccount = createAsyncThunk(
  'wechat/saveAccount',
  async ({ appId, appSecret, encryptKey, accountId }, { rejectWithValue }) => {
    try {
      return await saveAccountApi({ appId, appSecret, encryptKey, accountId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const deleteAccount = createAsyncThunk(
  'wechat/deleteAccount',
  async ({ accountId }, { rejectWithValue }) => {
    try {
      return await deleteAccountApi({ accountId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const resetStatus = createAction('wechat/resetStatus');
